import { render, staticRenderFns } from "./SToast.vue?vue&type=template&id=18d14e60&scoped=true&"
import script from "./SToast.vue?vue&type=script&lang=js&"
export * from "./SToast.vue?vue&type=script&lang=js&"
import style0 from "./SToast.vue?vue&type=style&index=0&id=18d14e60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d14e60",
  null
  
)

export default component.exports